import { render, staticRenderFns } from "./ContingentItem.vue?vue&type=template&id=3611adda&scoped=true&"
import script from "./ContingentItem.vue?vue&type=script&lang=js&"
export * from "./ContingentItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3611adda",
  null
  
)

export default component.exports